import { BrowserModule} from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {CdkTableModule} from '@angular/cdk/table';
import { HttpClientModule } from '@angular/common/http';
import { TaskModule } from './module/task.module';

import {MatAutocompleteModule} from '@angular/material/autocomplete';
// import {MatBadgeModule} from '@angular/material/badge';
// import {MatBottomSheetModule} from '@angular/material/bottom-sheet';
import {MatButtonModule} from '@angular/material/button';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
// import {MatCardModule} from '@angular/material/card';
import {MatCheckboxModule} from '@angular/material/checkbox';
// import {MatChipsModule} from '@angular/material/chips';
// import {MatStepperModule} from '@angular/material/stepper';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatDialogModule} from '@angular/material/dialog';
// import {MatDividerModule} from '@angular/material/divider';
// import {MatExpansionModule} from '@angular/material/expansion';
// import {MatGridListModule} from '@angular/material/grid-list';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
// import {MatListModule} from '@angular/material/list';
import {MatMenuModule} from '@angular/material/menu';
import {MatNativeDateModule,MAT_DATE_LOCALE, DateAdapter} from '@angular/material/core';
import {MatPaginatorModule, MatPaginatorIntl} from '@angular/material/paginator';
// import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
// import {MatRadioModule} from '@angular/material/radio';
// import {MatSelectModule} from '@angular/material/select';
// import {MatSidenavModule} from '@angular/material/sidenav';
// import {MatSliderModule} from '@angular/material/slider';
// import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatSortModule} from '@angular/material/sort';
import {MatTableModule} from '@angular/material/table';
import {MatTabsModule} from '@angular/material/tabs';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatTooltipModule} from '@angular/material/tooltip';
// import {MatTreeModule} from '@angular/material/tree';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { TopPageComponent } from './page/top-page/top-page.component';
import { LoginComponent } from './page/login/login.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { JpDateAdapterModule } from './module/jp-date-adapter.module';
import { MyMatPaginatorIntlModule } from './module/my-mat-paginator-intl.module';
import { ErrorNotificationDialogComponent } from './dialog/error-notification-dialog/error-notification-dialog.component';
import { OrderEditDialogComponent } from './dialog/order-edit-dialog/order-edit-dialog.component';
import { StockEditDialogComponent } from './dialog/stock-edit-dialog/stock-edit-dialog.component';
import { SpinnerDialogComponent } from './dialog/spinner-dialog/spinner-dialog.component';
import { OrderComponent } from './page/order/order.component';
import { StockComponent } from './page/stock/stock.component';
import { NumberOnlyDirective } from './directive/number-only.directive';
import { ItemParamPipe } from './pipe/item-param.pipe';
import { CtgParamEditComponent } from './page/ctg-param-edit/ctg-param-edit.component';
import { ParamCtgEditDialogComponent } from './dialog/param-ctg-edit-dialog/param-ctg-edit-dialog.component';
import { ItemParamEditComponent } from './page/item-param-edit/item-param-edit.component';
import { ParamItemEditDialogComponent } from './dialog/param-item-edit-dialog/param-item-edit-dialog.component';
import { ItemOrderStopEditComponent } from './page/item-order-stop-edit/item-order-stop-edit.component';
import { ItemOrderStopEditDialogComponent } from './dialog/item-order-stop-edit-dialog/item-order-stop-edit-dialog.component';
import { TableItemDialogComponent } from './dialog/table-item-dialog/table-item-dialog.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { OpestatPageComponent } from './page/opestat/opestat-page/opestat-page.component';
import { OpestatViewComponent } from './page/opestat/opestat-view/opestat-view.component';
import { OpestatViewMainComponent } from './page/opestat/opestat-view/opestat-view-main.component';
import { OpestatViewDistrComponent } from './page/opestat/opestat-view/opestat-view-distr.component';
import { ItemHistComponent } from './page/item-hist/item-hist.component';
import { ReportComponent } from './page/report/report.component';
import { RoleComponent } from './page/mng/role/role.component';
import { Role2Component } from './page/mng/role2/role2.component';
import { YesNoDialogComponent } from './dialog/yes-no-dialog/yes-no-dialog.component';
import { NoisecutComponent } from './page/noisecut/noisecut.component';
import { PasswdComponent } from './page/mng/passwd/passwd.component';
import { UserComponent } from './page/mng/user/user.component';
import { DownldComponent } from './page/downld/downld.component';
import { ItemNoisecutDialogComponent } from './dialog/item-noisecut-dialog/item-noisecut-dialog.component';
import { LogoutComponent } from './page/logout/logout.component';
import { ItemComponent } from './page/item/item.component';
import { RackComponent } from './page/rack/rack.component';
import { ScanItemEditComponent } from './page/scan-item-edit/scan-item-edit.component';
import { CtgHistComponent } from './page/ctg-hist/ctg-hist.component';
import { OrderStopTermCtgComponent } from './page/order-stop-term-ctg/order-stop-term-ctg.component';
import { OrderStopTermSuppComponent } from './page/order-stop-term-supp/order-stop-term-supp.component';
import { OrderStopTermStoreComponent } from './page/order-stop-term-store/order-stop-term-store.component';
import { OrderStopTermItemComponent } from './page/order-stop-term-item/order-stop-term-item.component';
import { AllStoreParamItemComponent } from './page/all-store-param-item/all-store-param-item.component';
import { AllStoreParamCtgComponent } from './page/all-store-param-ctg/all-store-param-ctg.component';
import { ExternalLinkComponent } from './page/external-link/external-link.component';
import { ItemReplaceComponent } from './page/item-replace/item-replace.component';
import { ForecastUpDownComponent } from './page/forecast-up-down/forecast-up-down.component';
import { DecimalPipe } from '@angular/common';
import { StoreGroupMngComponent } from './page/store-group-mng/store-group-mng.component';
import { NotificationDialogComponent } from './dialog/notification-dialog/notification-dialog.component';
import { CameraDialogComponent } from './dialog/camera-dialog/camera-dialog.component';
import { CsvParamItemComponent } from './page/csv-param-item/csv-param-item.component';
import { CsvSeasonalCategoryTargetComponent } from './page/csv-seasonal-category-target/csv-seasonal-category-target.component';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { OperationLogComponent } from './page/operation-log/operation-log.component';
import { CameraComponent } from './page/camera/camera/camera.component';
import { PbiAnalysisComponent } from './page/power-bi/pbi-analysis/pbi-analysis.component';
import { PbiReportListComponent } from './page/power-bi/pbi-report-list/pbi-report-list.component';
import { PbiMenuComponent } from './page/power-bi/pbi-menu/pbi-menu.component';
import { CameraLayoutComponent } from './page/camera/camera-layout/camera-layout.component';
import { CameraLayoutConfigComponent } from './page/camera/camera-layout-config/camera-layout-config.component';
import { CsvNoisecutPromComponent } from './page/csv-noisecut-prom/csv-noisecut-prom.component';
import { DisabledControlDirective } from './directive/disable-control-directive';
import { CsvVisitorsComponent } from './page/csv-visitors/csv-visitors.component';
import { CsvInventoryComponent } from './page/csv-inventory/csv-inventory.component';
import { CsvOrderComponent } from './page/csv-order/csv-order.component';
import { MenuItemComponent } from './page/mng/menu-item/menu-item.component';
import { MenuEditComponent } from './page/mng/menu-edit/menu-edit.component';
import { PromOrderComponent } from './page/prom-order/prom-order/prom-order.component';
import { ForecastUpDownNewComponent } from './page/forecast-up-down-new/forecast-up-down-new.component';
import { CsvUpDownComponent } from './page/csv-up-down/csv-up-down.component';
import { NoisecutNewComponent } from './page/noisecut-new/main/noisecut-new.component';
import { NoisecutSearchComponent } from './page/noisecut-new/search/noisecut-search/noisecut-search.component';
import { ItemReplaceNewComponent } from './page/item-replace-new/item-replace-new.component';
import { CsvParamStoreItemComponent } from './page/csv-param-store-item/csv-param-store-item.component';
import { SafeHtmlPipe } from './pipe/sale-html-pipe';
import { PromOrderEditComponent } from './page/prom-order/prom-order-edit/prom-order-edit.component';
import { PromRefDialogComponent } from './page/prom-order/prom-ref-dialog/prom-ref-dialog.component';
import { BarcodeDialogComponent } from './dialog/barcode-dialog/barcode-dialog.component';
import { OrderByUserComponent } from './page/order-by-user/order-by-user.component';
import { SelectOrderGroupComponent } from './page/order-by-user/select-order-group/select-order-group.component';
import { ItemSummaryDialogComponent } from './dialog/item-summary-dialog/item-summary-dialog.component';
import { LossRateComponent } from './page/loss-rate/loss-rate.component';
import { OrderGroupUserSingleComponent } from './page/order-group-user-single/order-group-user-single.component';
import { OrderStockComponent } from './page/order-stock/order-stock.component';
import { ScanItemEdit2Component } from './page/scan-item-edit2/scan-item-edit2.component';
import { PromSimComponent } from './page/prom-sim/prom-sim/prom-sim.component';
import { PromSimEditComponent } from './page/prom-sim/prom-sim-edit/prom-sim-edit.component';
import { PromSelectDialogComponent } from './dialog/prom-select-dialog/prom-select-dialog.component';
import { PromSelectListDialogComponent } from './dialog/prom-select-list-dialog/prom-select-list-dialog.component';
import { OrderApprovalComponent } from './page/order-approval/order-approval/order-approval.component';
import { OrderGroupUserMultiComponent } from './page/order-group-user-multi/order-group-user-multi.component';
import { OrderGroupUserMulti2Component } from './page/order-group-user-multi2/order-group-user-multi2.component';
import { NotificationEditComponent } from './page/notification/notification-edit/notification-edit.component';
import { OrderEditBgcolorDialogComponent } from './dialog/order-edit-bgcolor/order-edit-bgcolor-dialog.component';
import { TaskDashboardHqComponent } from './page/task/task-dashboard-hq/task-dashboard-hq.component';
import { TaskDashboardStoreComponent } from './page/task/task-dashboard-store/task-dashboard-store.component';
import { ExpiryLogComponent } from './page/expiry-log/expiry-log.component';
import { ScanItemEdit2DialogComponent } from './dialog/scan-item-edit2-dialog/scan-item-edit2-dialog.component';
import { CsvImportDeadlineMasterComponent } from './page/csv-import-deadline-master/csv-import-deadline-master.component';
import { ItemExpiryMasterComponent } from './page/item-expiry/item-expiry-master/item-expiry-master.component';
import { PrinterLayoutComponent } from './page/printer/printer-layout/printer-layout.component';
import { ItemExpiryItemMasterComponent } from './page/item-expiry/item-expiry-item-master/item-expiry-item-master.component';
import { ItemExpiryCtgDialogComponent } from './page/item-expiry/item-expiry-ctg-dialog/item-expiry-ctg-dialog.component';
import { HtmlSelectItemEditComponent } from './page/mng/html-select-item-edit/html-select-item-edit.component';
import { ImageDbEditComponent } from './page/image-db/image-db-edit/image-db-edit.component';
import { ImageDbViewComponent } from './page/image-db/image-db-view/image-db-view.component';
import { WeeklyOrderComponent } from './page/eob/weekly_order/weekly_order.component';
import { OrderListComponent } from './page/eob/order-list/order-list.component';
import { CtgSelectEobComponent } from './page/eob/ctg-eob-select/ctg-eob-select.component';
import { PreOrderListComponent } from './page/eob/pre-order-list/pre-order-list.component';
import { UrgentOrderListComponent } from './page/eob/urgent-order-list/urgent-order-list.component';
import { ResizeColumnDirective } from './page/eob/1_service/resize-column.directive';
import { GuideComponent } from './page/eob/guide/guide.component';
import { ItemExpiryComponent } from './page/item-expiry/item-expiry/item-expiry.component';
import { QrcodeDialogComponent } from './dialog/qrcode-dialog/qrcode-dialog.component';
import { LabelPrinterDialogComponent } from './page/printer/label-printer-dialog/label-printer-dialog.component';
import { ItemExpiryInitialComponent } from './page/item-expiry/item-expiry-initial/item-expiry-initial.component';
import { OrderGroupSelectDialogComponent } from './dialog/order-group-select-dialog/order-group-select-dialog.component';
import { ItemExpiryEditComponent } from './page/item-expiry/item-expiry-edit/item-expiry-edit.component';
import { ItemExpirySummaryComponent } from './page/item-expiry/item-expiry-summary/item-expiry-summary.component';
import { ItemExpiryInitialMainComponent } from './page/item-expiry/item-expiry-initial-main/item-expiry-initial-main.component';
import { ItemExpiryInitialDialogComponent } from './page/item-expiry/item-expiry-initial-dialog/item-expiry-initial-dialog.component';
import { ItemExpiryEditDialogComponent } from './page/item-expiry/item-expiry-edit-dialog/item-expiry-edit-dialog.component';
import { SettingLimitParamDialogComponent } from './dialog/setting-limit-param-dialog/setting-limit-param-dialog.component';
import { LimitTimeParamSettingComponent } from './page/limit-time-param-setting/limit-time-param-setting.component';
import { BarcodeScanDialogComponent } from './dialog/barcode-scan-dialog/barcode-scan-dialog.component';
import { ToolBarComponent } from './partsCommon/tool-bar/tool-bar.component';
import { TopBarComponent } from './partsCommon/top-bar/top-bar.component';
import { PartsCommonModule } from './module/parts-common.module';
import { AllStoreParamItemLimitComponent } from './page/all-store-param-item-limit/all-store-param-item-limit/all-store-param-item-limit.component';
import { TestComponent } from './page/test/test.component';

@NgModule({
  declarations: [
    AppComponent,
    TopPageComponent,
    LoginComponent,
    TopBarComponent,
    ToolBarComponent,
    ErrorNotificationDialogComponent,
    NotificationDialogComponent,
    OrderEditDialogComponent,
    StockEditDialogComponent,
    SpinnerDialogComponent,
    YesNoDialogComponent,
    OrderComponent,
    TestComponent,
    StockComponent,
    NumberOnlyDirective,
    ItemParamPipe,
    CtgParamEditComponent,
    ParamCtgEditDialogComponent,
    ItemParamEditComponent,
    ParamItemEditDialogComponent,
    ItemOrderStopEditComponent,
    ItemOrderStopEditDialogComponent,
    TableItemDialogComponent,
    OpestatPageComponent,
    OpestatViewComponent,
    OpestatViewMainComponent,
    OpestatViewDistrComponent,
    ItemHistComponent,
    ReportComponent,
    RoleComponent,
    Role2Component,
    NoisecutComponent,
    NoisecutNewComponent,
    PasswdComponent,
    UserComponent,
    DownldComponent,
    ItemNoisecutDialogComponent,
    LogoutComponent,
    ItemComponent,
    RackComponent,
    ScanItemEditComponent,
    ScanItemEdit2Component,
    CtgHistComponent,
    OrderStopTermCtgComponent,
    OrderStopTermSuppComponent,
    OrderStopTermStoreComponent,
    OrderStopTermItemComponent,
    AllStoreParamItemComponent,
    AllStoreParamCtgComponent,
    ExternalLinkComponent,
    ItemReplaceComponent,
    ForecastUpDownComponent,
    ForecastUpDownNewComponent,
    StoreGroupMngComponent,
    CameraComponent,
    CameraDialogComponent,
    CsvParamItemComponent,
    CsvSeasonalCategoryTargetComponent,
    CsvUpDownComponent,
    OperationLogComponent,
    PbiAnalysisComponent,
    PbiReportListComponent,
    PbiMenuComponent,
    CameraLayoutComponent,
    CameraLayoutConfigComponent,
    CsvNoisecutPromComponent,
    CsvVisitorsComponent,
    DisabledControlDirective,
    CsvInventoryComponent,
    CsvOrderComponent,
    MenuItemComponent,
    MenuEditComponent,
    PromOrderComponent,
    NoisecutSearchComponent,
    ItemReplaceNewComponent,
    CsvParamStoreItemComponent,
    SafeHtmlPipe,
    CsvParamStoreItemComponent,
    PromOrderEditComponent,
    PromRefDialogComponent,
    PromSimComponent,
    PromSimEditComponent,
    PromSelectDialogComponent,
    PromSelectListDialogComponent,
    BarcodeDialogComponent,
    OrderByUserComponent,
    SelectOrderGroupComponent,
    OrderGroupSelectDialogComponent,
    ItemSummaryDialogComponent,
    LossRateComponent,
    OrderGroupUserSingleComponent,
    OrderStockComponent,
    ItemExpiryMasterComponent,
    ItemExpiryItemMasterComponent,
    ItemExpiryComponent,
    ItemExpiryInitialMainComponent,
    ItemExpiryInitialComponent,
    ItemExpiryInitialDialogComponent,
    ItemExpiryEditComponent,
    ItemExpiryEditDialogComponent,
    ItemExpirySummaryComponent,
    ItemExpiryCtgDialogComponent,
    OrderApprovalComponent,
    OrderGroupUserMultiComponent,
    OrderGroupUserMulti2Component,
    NotificationEditComponent,
    OrderEditBgcolorDialogComponent,
    ExpiryLogComponent,
    ScanItemEdit2DialogComponent,
    CsvImportDeadlineMasterComponent,
    PrinterLayoutComponent,
    PrinterLayoutComponent,
    ImageDbEditComponent,
    ImageDbViewComponent,
	  WeeklyOrderComponent,
	  OrderListComponent,
    CtgSelectEobComponent,
    PreOrderListComponent,
    UrgentOrderListComponent,
    ResizeColumnDirective,
    GuideComponent,
    HtmlSelectItemEditComponent,
    QrcodeDialogComponent,
    LabelPrinterDialogComponent,
    SettingLimitParamDialogComponent,
    LimitTimeParamSettingComponent,
    BarcodeScanDialogComponent,
    AllStoreParamItemLimitComponent,

    TaskDashboardHqComponent,
    TaskDashboardStoreComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    CdkTableModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,

    MatAutocompleteModule,
    // MatBadgeModule,
    // MatBottomSheetModule,
    MatButtonModule,
    MatButtonToggleModule,
    // MatCardModule,
    MatCheckboxModule,
    // MatChipsModule,
    // MatStepperModule,
    MatDatepickerModule,
    MatDialogModule,
    // MatDividerModule,
    // MatExpansionModule,
    // MatGridListModule,
    MatIconModule,
    MatInputModule,
    // MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    // MatProgressBarModule,
    MatProgressSpinnerModule,
    // MatRadioModule,
    // MatRippleModule,
    // MatSelectModule,
    // MatSidenavModule,
    // MatSliderModule,
    // MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    // MatTreeModule,
    DragDropModule,
    NgxChartsModule,

    PartsCommonModule,
    // TaskModule
  ],
  providers: [
    {provide: MAT_DATE_LOCALE, useValue: 'ja-JP'},
    {provide: DateAdapter, useClass: JpDateAdapterModule},
    {provide: MatPaginatorIntl, useClass: MyMatPaginatorIntlModule},
    DecimalPipe
  ],
  entryComponents: [
    ErrorNotificationDialogComponent,
    NotificationDialogComponent,
    SpinnerDialogComponent,
    YesNoDialogComponent,
    OrderEditDialogComponent,
    StockEditDialogComponent,
    ParamCtgEditDialogComponent,
    ParamItemEditDialogComponent,
    ItemOrderStopEditDialogComponent,
    TableItemDialogComponent,
    ItemNoisecutDialogComponent,
    CameraDialogComponent,
    // TaskPhotoDialogComponent,
    // TaskPhotoViewDialogComponent,
    PromRefDialogComponent,
    PromSelectDialogComponent,
    PromSelectListDialogComponent,
    BarcodeDialogComponent,
    SelectOrderGroupComponent,
    OrderGroupSelectDialogComponent,
    ItemSummaryDialogComponent,
    OrderEditBgcolorDialogComponent,
    ScanItemEdit2DialogComponent,
    ItemExpiryCtgDialogComponent,
    QrcodeDialogComponent,
    LabelPrinterDialogComponent,
    ItemExpiryInitialDialogComponent,
    ItemExpiryEditDialogComponent,
    BarcodeScanDialogComponent
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
